import { render, staticRenderFns } from "./UiPrimaryColorPicker.vue?vue&type=template&id=250982cd&scoped=true&"
import script from "./UiPrimaryColorPicker.vue?vue&type=script&lang=js&"
export * from "./UiPrimaryColorPicker.vue?vue&type=script&lang=js&"
import style0 from "./UiPrimaryColorPicker.vue?vue&type=style&index=0&id=250982cd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "250982cd",
  null
  
)

export default component.exports